import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ChevronLeftOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_71)'>
        <path
          d='M13.36 16.9999C13.2253 16.9994 13.0921 16.9717 12.9684 16.9184C12.8446 16.8652 12.7329 16.7874 12.64 16.6899L8.78 12.6899C8.59677 12.503 8.49414 12.2517 8.49414 11.9899C8.49414 11.7282 8.59677 11.4769 8.78 11.2899L12.78 7.28994C12.8732 7.1967 12.9839 7.12274 13.1057 7.07228C13.2276 7.02182 13.3581 6.99585 13.49 6.99585C13.6219 6.99585 13.7524 7.02182 13.8742 7.07228C13.9961 7.12274 14.1068 7.1967 14.2 7.28994C14.2932 7.38318 14.3672 7.49387 14.4177 7.61569C14.4681 7.73751 14.4941 7.86808 14.4941 7.99994C14.4941 8.1318 14.4681 8.26237 14.4177 8.38419C14.3672 8.50601 14.2932 8.6167 14.2 8.70994L10.9 11.9999L14.08 15.2999C14.2662 15.4873 14.3708 15.7408 14.3708 16.0049C14.3708 16.2691 14.2662 16.5226 14.08 16.7099C13.9854 16.8038 13.8729 16.8778 13.7493 16.9276C13.6256 16.9775 13.4933 17.002 13.36 16.9999Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_71'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
